import React from 'react'

const Progress_bar = ({bgcolor,progress,height,targetVal}) => {	
	const container = {
		width: '40%',
		top: '271px',
		left: '78px',
		padding: 0,
		height: height+'px',
		verticalAlign: 'middle',
		align:'left'
	}
	const box = {
		backgroundColor:'#CBCBCB',
		position: 'absolute',
		left: '1px',
		zIndex: 1,
		width:'100%',
		height: +(height/2) + 6+'px',
		marginTop: (height/6)+'px',
		// border: '1px solid gray',
	  	// borderRadius: '6px',
	}
	
	const box1 = {
		backgroundColor:'#CBCBCB',
		position: 'absolute',
		left: '1px',
		zIndex: 1,
		width:'92%',
		height: +height + 1+'px',
		// border: '1px solid gray',
		borderRadius: '4px',
		align:'left'
	}


	const box2= {
		position: 'absolute',
		left: targetVal<=85?targetVal+'%':targetVal>85?'85%':'',
		top: '18px',
		zIndex: 2,
		borderLeft: '4px solid transparent',
		borderRight: '4px solid transparent',
		borderBottom: '8px solid #000',
		background: 'transparent'
	}

	const progressBox = {
		backgroundColor:progress===-1?'':progress===undefined?'':progress!==''?bgcolor:'',
		left: '3px',
		width: progress!==''?progress+'%':'',
		height:height+'px',
		align:'left',
		// border: '1px solid gray',
		// borderRadius: '4px',
		borderTopLeftRadius : '4px',
		borderBottomLeftRadius : '4px',
	}
		
	return (
		<div style={container}>
			<div style={box}></div>
			{ targetVal !== 0 ? <div style={box2}></div> : ''}
			<div style={box1}>
				<div style={progressBox}></div>
			</div>
		</div>
	)
}

export default Progress_bar;
